module.exports = __webpack_public_path__ + "media/images/common/shop_reserve/headphone-a78c5f0ef9f7796d88ebca39a7364494.svg";